import { InputAdornment, TextField } from '@mui/material'
import React, { ChangeEvent } from 'react'

const GlobalInput = ({
    label,
    type = 'text',
    name,
    placeholder,
    onChange,
    isError,
    value,
    inputRef,
    shrink,
    classes,
    disabled = false,
    onBlur = ()=>{},
    showStartAdornment,
    startAdornment,
    onPaste,
    size
}: {
    label: string
    type?: string
    name: string
    placeholder?: string
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    isError?: boolean
    value?: string
    inputRef?: any
    shrink?: boolean
    classes?: string
    disabled?: boolean
    onBlur?:any
    showStartAdornment?:boolean
    startAdornment?:any
    onPaste?:any,
    size?: 'small' | 'medium'
}) => {
    return (
        <div className={`w-full ${classes}`}>
            <TextField
                error={isError}
                label={label}
                autoComplete='off'
                variant="outlined"
                className='w-full'
                type={type}
                name={name}
                onChange={onChange}
                placeholder={placeholder}
                size={size || 'small'}
                value={value || ""}
                disabled={disabled}
                onBlur={onBlur}
                sx={{
                    '& .css-10m55e3-MuiFormLabel-root-MuiInputLabel-root': {
                        fontSize: '0.8rem',
                    },
                    '& .css-p51h6s-MuiInputBase-input-MuiOutlinedInput-input': {
                        fontSize: '0.8rem',
                        padding: '16px'
                    },
                    '& .MuiInputBase-input:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0 100px #000 inset',
                    },
                    '& input[type=number]::-webkit-inner-spin-button': {
                        '-webkit-appearance': 'none',
                        margin: 0
                    },
                    '& .css-1ea1xhh-MuiInputBase-input-MuiOutlinedInput-input': {
                        fontSize: '0.8rem'
                    }
                }}
                inputRef={inputRef}
                InputLabelProps={{
                    shrink: shrink,
                }}
                onPause={onChange}
                onPaste={onPaste ? onPaste : onChange}
                InputProps={{
                    startAdornment: showStartAdornment ? <InputAdornment position="start">{startAdornment}</InputAdornment> : <></>,
                  }}
            />
        </div>
    )
}

export default GlobalInput